import { useState, useEffect, useRef } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { localStoreObjects } from "../utilities/util";
import { useAuth } from "./features/AuthContext";
import APIDropdown from "./APIDropdown";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef(null);
  const { isAuthenticated, logout } = useAuth();

  const [selectedHost, setSelectedHost] = useState(() => {
    return localStorage.getItem("apiHost") || "http://localhost:8008/";
  });

  const apiHosts = [
    { label: "Production", value: "https://api.v2.production.smartmatrimony.ai/" },
    { label: "Staging", value: "https://llm.api.smartmaheshwari.com/" },
    { label: "Localhost", value: "http://localhost:8008/" }
  ];

  const handleHostChange = (value) => {
    setSelectedHost(value);
    localStorage.setItem("apiHost", value);
    localStorage.setItem("cachedUsers", "")
    window.location.reload();
  };

  useEffect(() => {

    const handleOutsideClick = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleOutsideClick);
    } else {
      document.removeEventListener("mousedown", handleOutsideClick);
    }

    return () => document.removeEventListener("mousedown", handleOutsideClick);
  }, [isOpen]);

  const toggleMenu = () => setIsOpen(!isOpen);
  const closeMenu = () => setIsOpen(false);

  const navLinks = [
    // { to: "/dashboard", label: "Dashboard" },
  ];

  if (!isAuthenticated) {
    navLinks.push({ to: "/login", label: "Login" });
  } else {
    navLinks.push({
      to: "#",
      label: "Logout",
      onClick: () => {
        localStorage.removeItem(localStoreObjects.userId);
        localStorage.removeItem(localStoreObjects.bgmiProfile);
        localStorage.removeItem(localStoreObjects.profilePic);
        localStorage.removeItem(localStoreObjects.step);
        logout()
      }
    });
  }

  return (
    <nav className="bg-white/10 backdrop-blur-md border-b border-white/20 text-white shadow-sm z-50">
      <div className="max-w-7xl mx-auto flex justify-between items-center px-4 py-3">
        <Link
          to="/"
          className="text-2xl font-extrabold text-yellow-400 tracking-widest"
        >
          💍 Matrimony
        </Link>

        {/* Toggle for mobile */}
        <button onClick={toggleMenu} className="md:hidden text-white focus:outline-none">
          {isOpen ? <X size={28} /> : <Menu size={28} />}
        </button>

        {/* Desktop Menu */}
        <div className="hidden md:flex space-x-8 items-center text-sm font-semibold">
          {navLinks.map(({ to, label, onClick }) => (
            <NavLink
              key={label}
              to={to}
              onClick={onClick}
              className={({ isActive }) =>
                `transition-all duration-150 hover:text-yellow-300 ${isActive ? "text-yellow-400 border-b-2 border-yellow-400 pb-1" : ""
                }`
              }
            >
              {label}
            </NavLink>
          ))}
        </div>

        <APIDropdown
          selectedHost={selectedHost}
          setSelectedHost={handleHostChange}
          apiHosts={apiHosts}
        />

      </div>

      {/* Mobile Menu */}
      {isOpen && (
        <div
          ref={menuRef}
          className="md:hidden text-center space-y-2 py-3 text-sm font-medium border-t border-white/10 bg-white/5 backdrop-blur-lg"
        >
          {navLinks.map(({ to, label, onClick }) => (
            <NavLink
              key={label}
              to={to}
              onClick={(e) => {
                if (onClick) onClick();
                closeMenu();
              }}
              className={({ isActive }) =>
                `block py-2 transition ${isActive
                  ? "text-yellow-400 border-b border-yellow-400"
                  : "text-white hover:text-yellow-300"
                }`
              }
            >
              {label}
            </NavLink>
          ))}
        </div>
      )}
    </nav>
  );
};

export default Navbar;
